export default __webpack_public_path__ + "static/media/logo_banner.b1d01e90.png";